import React from 'react';
import { CountryConfig } from './interfaces/Config';
import header_img_dark from "./header.jpg";

interface LanguageGridProps {
    country: CountryConfig;
}

const LanguageGrid = ({ country}: LanguageGridProps) => {

    return (
        <header className="Home-Selection">
            <div className="App_body">
                <div className={"panel_onboard"}>
                    Select your Language:
                    <div style={styles.gridContainer}>
                        {country.AvailableLangs.map((language, index) => (
                            <a href={`${window.location.href}/${country.AvailableLangs[index]}`} style={styles.link}>
                                <div key={index} style={styles.countryContainer}>
                                    <img src={country.FlagUrl} alt={`${language} flag`} style={styles.flag} />
                                    <p>{country.NameLangs[index]}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </header>
    );
};

const styles = {
    gridContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '30%',
        padding: '0px 20% 0px 20%'
    } as React.CSSProperties,
    countryContainer: {
        textAlign: 'center'
    } as React.CSSProperties,
    flag: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        objectFit: 'cover',
        objectPosition: 'center'
    } as React.CSSProperties,
    link: {
        textDecoration: 'none',
        color: 'inherit'
    } as React.CSSProperties
};

export default LanguageGrid;
